import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import Input from 'components/common/Input';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
// import bg2 from 'assets/img/icons/spot-illustrations/corner-4.png';
import { Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';
// import Background from 'components/common/Background';
import { useSearchParams } from 'react-router-dom';

const ArticleSingleImage = ({ image, name, layout }) => {
 return (
  <Image
   rounded={layout === 'list'}
   src={image}
   name={name}
   className={classNames('h-100 w-100 fit-cover', {
    'rounded-top': layout === 'grid'
   })}
   alt={name}
  />
 );
};

const ArticleImage = ({ name, id, images, layout, setValue }) => {
 const imageArray = Object.values(images);
 const sliderSettings = {
  autoplay: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  beforeChange: (current, next) => handleImageChange(next)
 };

 const handleImageChange = index => {
  const currentImage = images[index];
  setValue('image', [currentImage]);
 };

 return (
  <div
   className={classNames('position-relative rounded-top overflow-hidden', {
    'h-sm-100': layout === 'list'
   })}
  >
   {imageArray.length === 1 && <ArticleSingleImage id={id} image={imageArray[0]} name={name} layout={layout} />}

   {imageArray.length > 1 && (
    <Slider {...sliderSettings} className="product-image-slider slick-slider-arrow-inner h-100 full-height-slider">
     {imageArray.map((image, index) => (
      <ArticleSingleImage key={index} id={id} image={image} name={name} layout={layout} />
     ))}
    </Slider>
   )}
  </div>
 );
};

const Article = ({ article, articles }) => {
 const {
  watch,
  setValue,
  formState: { errors }
 } = useFormContext();

 const [searchParams, setSearchParams] = useSearchParams();
 const [options, setOptions] = useState([]);

 const selts = watch('article') ?? '';
 const selects = () => options.find(e => e.value === selts) ?? '';

 const [select, setSelect] = useState(selects());

 useEffect(() => {
  setSelect(selects());
 }, [selts]);

 useEffect(() => {
  setSelect(selects());
 }, [options]);

 useEffect(() => {
  setOptions(articles);
 }, [articles]);

 return (
  <Card className="mb-3">
   <Card.Header className="p-0 p-md-3 position-relative">
    {article ? (
     <Row className="g-3">
      <Col md={2}>
       <ArticleImage name={'name'} id={1} images={article?.images} layout="list" setValue={setValue} />
      </Col>
      <Col lg={9} as={Flex} className="flex-column">
       <Flex className="px-3" justifyContent="center" alignItems="center" wrap="nowrap">
        <div className="flex-grow-1">
         <h5 className="mb-0 fs--1 text-capitalize">{article?.code}</h5>
         <h4 className="m-0 fs--1 fs-md-0 fs-lg-0 text-capitalize">{article?.name.toLowerCase()}</h4>
        </div>
        <SoftBadge pill bg="primary">
         <FontAwesomeIcon icon="pen-nib" className="me-1" transform="shrink-4" />
         {article?.measuring}
        </SoftBadge>
       </Flex>

       <p className="fs--2 fs-md--1 text-end text-md-start px-3">{`Creado por ${article?.manufacturer} - id ${article?.identification}`}</p>
       <div className="flex-1 d-flex align-items-end fw-semi-bold fs--2 fs-md--1 d-none d-sm-block">
        <span className="me-1 text-900">{3.5}</span>
        <span className="ms-2 text-secondary">popularidad</span>
       </div>
      </Col>
     </Row>
    ) : (
     <></>
    )}
    {/* <Background image={bg2} className="d-none d-md-block bg-card" /> */}
   </Card.Header>

   <Card.Body>
    <Flex justifyContent="start" alignItems="center" wrap="nowrap">
     <div className="flex-grow-1 text-truncate">
      <h5 className="mb-0 fs-0">Articulos</h5>
      <p className="m-0 fs--2 text-muted">Seleccione articulo a configurar</p>
     </div>
     <Input
      type="selectMulti"
      name="article"
      errors={errors}
      placeholder="Seleccione..."
      options={options}
      formGroupProps={{ className: 'ps-3 border-start border-start-2' }}
      formControlProps={{
       isClearable: false,
       isMulti: false,
       closeMenuOnSelect: true,
       value: select,
       onChange: newValue => {
        searchParams.set('code', newValue.value);
        setSearchParams(searchParams);
        setValue('name', newValue.label);
        setValue('article', newValue.value, { shouldValidate: true });
       }
      }}
     />
    </Flex>
   </Card.Body>
  </Card>
 );
};

ArticleSingleImage.propTypes = {
 id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
 image: PropTypes.string.isRequired,
 name: PropTypes.string.isRequired,
 layout: PropTypes.string.isRequired
};

ArticleImage.propTypes = {
 name: PropTypes.string.isRequired,
 id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
 images: PropTypes.array.isRequired,
 layout: PropTypes.string.isRequired,
 setValue: PropTypes.func.isRequired
};

Article.propTypes = {
 article: PropTypes.object,
 articles: PropTypes.array.isRequired
};

export default Article;
